import { inject } from '@angular/core'
import { toObservable } from '@angular/core/rxjs-interop'
import { ResolveFn } from '@angular/router'

import { Observable, map } from 'rxjs'

import { DetailedPermissions } from '../shared/workspace.utils'
import { WorkspacesAndPermissionsStore } from '../workspaces-and-permissions.store'

export const WorkspaceUsersPermissionsResolver: ResolveFn<
  DetailedPermissions
> = (): Observable<DetailedPermissions> => {
  const workspacesAndPermissionsStore = inject(WorkspacesAndPermissionsStore)
  return toObservable(workspacesAndPermissionsStore.userAccessRights)
}

export const WorkspaceGroupsPermissionsResolver: ResolveFn<
  DetailedPermissions
> = (): Observable<DetailedPermissions> => {
  const workspacesAndPermissionsStore = inject(WorkspacesAndPermissionsStore)
  return toObservable(workspacesAndPermissionsStore.userAndWorkspacePermissions).pipe(
    map((permissions) => ({
      canRead: !!permissions['wks_groups_read'],
      canCreate: !!permissions['wks_groups_create'],
      canEdit: !!permissions['wks_groups_edit'],
      canDelete: !!permissions['wks_groups_delete'],
    }))
  )
}

export const WorkspaceRolesPermissionsResolver: ResolveFn<
  DetailedPermissions
> = (): Observable<DetailedPermissions> => {
  const workspacesAndPermissionsStore = inject(WorkspacesAndPermissionsStore)
  return toObservable(workspacesAndPermissionsStore.userAndWorkspacePermissions).pipe(
    map((permissions) => ({
      canCreate: !!permissions['wks_roles_create'],
      canEdit: !!permissions['wks_roles_edit'],
      canDelete: !!permissions['wks_roles_delete'],
    }))
  )
}

export const WorkspaceThemesPermissionsResolver: ResolveFn<
  DetailedPermissions
> = (): Observable<DetailedPermissions> => {
  const workspacesAndPermissionsStore = inject(WorkspacesAndPermissionsStore)
  return toObservable(workspacesAndPermissionsStore.userAndWorkspacePermissions).pipe(
    map((permissions) => ({
      canEdit: !!permissions.theme_edit,
      canRead: !!permissions.theme_read,
      canDelete: !!permissions.theme_delete,
      canCreate: !!permissions.theme_create,
    }))
  )
}
